import type { RankedSlot } from "@/lib/targeting/rank-slots";
import type { ThreadListItem } from "@/lib/widget-thread";

/**
 * The thread-list row that stands in for the page's top launcher MESSAGE slot while the visitor has no
 * thread yet: same picked variant and ranking as the launcher bubble, the slot text as the preview and
 * the assistant as the heading. It has no chat (`chatId: ""`): the thread is created on the first send.
 */
export function slotListRow(
  top: RankedSlot | null,
  threadKey: (slotId: string, variantId: string) => string,
  senderName: string,
): ThreadListItem | null {
  if (!top) return null;
  return {
    chatId: "",
    threadKey: threadKey(top.slotId, top.variant.id),
    status: "OPEN",
    unreadCount: 0,
    updatedAt: "",
    preview: { text: top.variant.text, at: "", fromVisitor: false },
    senderName,
  };
}
